import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { InputImageCropperComponent } from '../input-image-cropper/input-image-cropper.component';
import { ModalImageCropperComponent } from '../modal-image-cropper/modal-image-cropper.component';

declare var $: any;


@Component({
  selector: 'form-group-upload-box-cropper',
  templateUrl: './form-group-upload-box-cropper.component.html',
  styleUrls: ['./form-group-upload-box-cropper.component.css']
})
export class FormGroupUploadBoxCropperComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() messageRequired: string = '';
  @Input() type: string = '';
  @Input() popoverContent: string = '';
  @Input() modalName: string = '';
  @Input() modalText: string = '';
  @Input() modalParentName: string = '';

  @ViewChild('modalImageCropper') modalImageCropper: ModalImageCropperComponent;
  @ViewChild('inputImageCropper') inputImageCropper: InputImageCropperComponent;

  constructor() { }



  onClickModalShow(event: MouseEvent) {
    event.preventDefault();
    $("#" + this.modalName).modal('show');
  }

  eventSelectFile(event: EventSelectFile) {

    this.modalImageCropper.selectFile(event);
  }

  eventSelectAnotherFile(event: any) {
    this.inputImageCropper.openSelectFile();
  }

  eventUploadPhotoCropped(event: EventUploadPhotoCropped) {
    this.inputImageCropper.onUploadPhoto(event)
  }
}
